<aside class="sidebar-wrapper" data-simplebar="true">
    <div class="sidebar-header">
        <div>
            <img src="assets/images/logo-icon.png" class="logo-icon" alt="logo icon">
        </div>
        <div>
            <h4 class="logo-text">TAH-BOT</h4>
        </div>
        <div class="toggle-icon ms-auto"> <i class="bi bi-list"></i>
        </div>
    </div>
    <!--navigation-->
    <ul class="metismenu" id="menu">
        <li [ngClass]="activeClass('dashboard')" *ngIf="admin == 'false'">
            <a (click)='route("dashboard")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-file-person"></i>
                </div>
                <div class="menu-title">DASHBOARD</div>
            </a>
        </li>
        <li [ngClass]="activeClass('users')" *ngIf="admin == 'true'">
            <a (click)='route("users")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-file-person"></i>
                </div>
                <div class="menu-title">USER ACCOUNTS</div>
            </a>
        </li>
        <li [ngClass]="activeClass('brokers')">
            <a (click)='route("brokers")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-laptop"></i>
                </div>
                <div class="menu-title">BROKERS</div>
            </a>
        </li>
        <li [ngClass]="activeClass('thread')">
            <a (click)='route("thread")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-calendar-range"></i>
                </div>
                <div class="menu-title">STRATEGIES</div>
            </a>
        </li>
        <li [ngClass]="activeClass('order-positions')" *ngIf="admin == 'true'">
            <a (click)='route("order-positions")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-calendar-range"></i>
                </div>
                <div class="menu-title">ORDERS & POSITIONS</div>
            </a>
        </li>
        <li [ngClass]="activeClass('tradeboard')" *ngIf="admin == 'true'">
            <a (click)='route("tradeboard")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-calendar-range"></i>
                </div>
                <div class="menu-title">TRADE BOARD</div>
            </a>
        </li>
        <li [ngClass]="activeClass('channel')" *ngIf="admin == 'true'">
            <a (click)='route("channel")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-journal-check"></i>
                </div>
                <div class="menu-title">CHANNELS</div>
            </a>
        </li>
        <li *ngIf="admin == 'true'">
            <!-- Should add monthly reports too-->
            <a class='has-arrow'[attr.aria-expanded]="!menus.report.collapsed" (click)="onMenuClicked('report')">
                <div class="parent-icon"><i class="bi bi-person-fill"></i>
                </div>
                <div class="menu-title">REPORTS</div>
            </a>
            <ul [ngClass]="showClass('report')">
                <li [ngClass]="activeClass('report-alerts')">
                    <a class="justify-content-center" (click)='route("report-alerts")'>
                        <div class="parent-icon"><i class="bi bi-person-fill"></i>
                        </div>
                        <div class="menu-title">ALERTS</div>
                    </a>
                </li>
            </ul>
        </li>
        <li *ngIf="admin == 'true'">
            <a class='has-arrow'[attr.aria-expanded]="!menus.entity.collapsed" (click)="onMenuClicked('entity')">
                <div class="parent-icon"><i class="bi bi-person-fill"></i>
                </div>
                <div class="menu-title">ENTITY</div>
            </a>
            <ul [ngClass]="showClass('entity')">
                <li [ngClass]="activeClass('entity-strategy')">
                    <a class="justify-content-left" (click)='route("entity-strategy")'>
                        <div class="parent-icon"><i class="bi bi-person-fill"></i>
                        </div>
                        <div class="menu-title">STRATEGY</div>
                    </a>
                </li>
                <li [ngClass]="activeClass('entity-instruments')">
                    <a class="justify-content-left" (click)='route("entity-instruments")'>
                        <div class="parent-icon"><i class="bi bi-person-fill"></i>
                        </div>
                        <div class="menu-title">INSTRUMENTS</div>
                    </a>
                </li>
            </ul>
        </li>
        <li [ngClass]="activeClass('data-collection')">
            <a (click)='route("data-collection")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-journal-text"></i>
                </div>
                <div class="menu-title">DATA COLLECTION</div>
            </a>
        </li>
        <li [ngClass]="activeClass('logs')">
            <a (click)='route("logs")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-journal-text"></i>
                </div>
                <div class="menu-title">LOGS</div>
            </a>
        </li>
        <!--li [ngClass]="activeClass('tutorial')">
            <a (click)='route("tutorial")'>
                <div class="parent-icon"><i class="bi bi-newspaper"></i>
                </div>
                <div class="menu-title">TUTORIALS</div>
            </a>
        </li-->
        <li [ngClass]="activeClass('settings')">
            <a (click)='route("settings")' aria-expanded="false">
                <div class="parent-icon"><i class="bi bi-person-lines-fill"></i>
                </div>
                <div class="menu-title">SETTINGS</div>
            </a>
        </li>
    </ul>
</aside>